/**
 * 로그인 비밀번호 전송 인코딩 — **UTF-8 Base64** (설계 §2-1(b), 위험 R1·R2).
 *
 * 🚨 구장 관리자 로그인 EP 는 비밀번호를 **Base64 로 받는다**. 서버 `Member.verifyPassword` 가
 * `Base64.getDecoder().decode(...)` 로 되돌린 **바이트열**을 저장된 해시와 대조하며, 회원가입은
 * 평문 바이트를 그대로 인코딩해 저장한다(#583 제약 D·D′). 따라서 **UTF-8 이 유일하게 정합한 선택**이고,
 * 평문을 그대로 보내면 400 `INVALID_PASSWORD_ENCODING` 으로 전원 로그인 불가가 된다.
 *
 * 🚨 `btoa(raw)` 를 그대로 쓰면 안 된다 — `btoa` 는 Latin-1(코드포인트 0~255)만 받는다.
 * 비밀번호에 한글이 한 글자라도 있으면 `InvalidCharacterError` 로 터져 "로그인 버튼을 눌러도
 * 아무 일도 일어나지 않는" 증상이 된다. 그래서 **UTF-8 바이트로 먼저 변환**한 뒤 인코딩한다.
 */
export function encodePassword(raw: string): string {
  const bytes = new TextEncoder().encode(raw)

  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }

  return btoa(binary)
}
